import { Action } from "@ngrx/store";
export enum HamptonValuationActionTypes {
  ChangeComparableOverview = '[Adjustment Tab] Change comparable overview',
  ChangeComparableAnalysis = '[Adjustment Tab] Change comparable analysis',

  UpdateAnalysis = '[Adjustment Tab] Update analysis of valuation' ,
  Reset = '[Valuation Process Effect] Reset Qualitative analysis',
  Load = '[Valuation Process Effect] Load qualitative analysis'
}

export class HamptonValuationChangeComparableOverview implements Action {
  readonly type = HamptonValuationActionTypes.ChangeComparableOverview
  constructor(public payload: {value: 'quantitative' | 'qualitative'}) {}
}

export class HamptonValuationChangeComparableAnalysis implements Action {
  readonly type = HamptonValuationActionTypes.ChangeComparableAnalysis
  constructor(public payload: {value: 'quantitative' | 'qualitative'}) {}
}

export class HamptonValuationReset implements Action {
  readonly type = HamptonValuationActionTypes.Reset
  constructor() {}
}

export class HamptonValuationLoad implements Action {
  readonly type = HamptonValuationActionTypes.Load
  constructor(public payload: {value: any}) {}
}


export class HamptonValuationUpdateAnalysis implements Action {
  readonly type = HamptonValuationActionTypes.UpdateAnalysis
  constructor(public payload: {
    comparablesPriceLowerEnd: number
    comparablesPriceHigherEnd: number,
    consultantLower: number,
    consultantHigher: number,
    valuerLower: number,
    valuerHigher: number,
    reasoning: string,
    valueRangeId: number,
    valueEstimated: number,
    rentalValueLower: number,
    rentalValueHigher: number,
    landValue: number,
    sizeSelection: number
  }) {}
}

export type HamptonValuationActions =
  | HamptonValuationChangeComparableOverview
  | HamptonValuationUpdateAnalysis
  | HamptonValuationChangeComparableAnalysis
  | HamptonValuationReset
  | HamptonValuationLoad